var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoorg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 140,
    viewBox: "0 0 180 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 43.3676H152.205V38.0586H28V43.3676Z",
    fill: "#E22C38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.13 53.0463H109.399V102.706H102.845V69.0169C102.845 66.1986 102.695 64.4071 102.179 62.6593C101.19 59.1636 98.8697 55.4495 95.9687 53.9639C94.2066 53.0463 92.1867 52.6749 90.0808 52.6749C87.6096 52.6749 85.3103 53.2211 83.3548 54.4664C80.7762 56.0831 78.7777 59.6006 77.8537 63.0088C77.424 64.5819 77.295 66.3297 77.295 69.0169V102.706H70.741V53.0463H57.0097V102.706H50.5201L50.4342 53.0463H37.1542V102.706H30.6216V53.0463H28V47.7373H152.205V53.0463H149.583V102.706H143.029V53.0463H129.663V102.706H123.13V53.0463Z",
    fill: "#E22C38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8486 29.8217L33.6736 24.5127L37.4556 29.8217L33.6736 35.1307L29.8486 29.8217Z",
    fill: "#E22C38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1685 124.313C49.4033 125.318 51.3158 127.721 51.3158 131.195C51.3158 135.674 48.9735 138.536 45.9866 139.41C44.1386 140 42.2261 140 40.4855 140H29.8486V109.675H41.1087C42.5055 109.675 44.0526 109.719 45.5998 110.134C48.2644 110.877 50.7356 113.215 50.7356 117.475C50.7356 121.408 48.5867 123.33 47.147 124.117V124.313H47.1685ZM41.3021 122.828C42.3335 122.828 43.3005 122.697 44.0956 122.216C45.256 121.56 46.0511 120.14 46.0511 118.021C46.0511 115.946 45.1056 114.569 43.7088 114.089C43.0427 113.805 42.2046 113.717 41.1302 113.717H34.4687V122.849H41.3021V122.828ZM46.4809 131.195C46.4809 128.989 45.4494 127.743 44.2031 127.219C43.408 126.891 42.484 126.804 41.6889 126.804H34.4687V136.024H41.6244C42.5055 136.024 43.3435 135.936 44.0097 135.696C45.5783 135.062 46.4809 133.62 46.4809 131.195Z",
    fill: "#E22C38"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6899 29.6251C51.7015 29.2536 50.9708 28.2923 50.9708 27.1344C50.9708 25.6706 52.0883 24.5127 53.528 24.5127C54.9248 24.5127 56.0422 25.6706 56.0422 27.1344C56.0422 28.2923 55.3545 29.2536 54.3661 29.5814L56.7943 34.7374H50.2617L52.6899 29.6251Z",
    fill: "#E22C38"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.1471 135.565L85.0312 140H55.8281L71.6653 109.675H81.3782V135.696L88.1471 135.565ZM76.844 135.893V113.368H73.8141L62.3177 135.893H76.844Z",
    fill: "#E22C38"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6768 34.3446H109.356V29.0356H70.6768V34.3446Z",
    fill: "#E22C38"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.4307 24.6659H98.1174V19.3569H82.4307V24.6659Z",
    fill: "#E22C38"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.2783 5.28714H95.8177V0H84.2783V5.28714Z",
    fill: "#E22C38"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5244 9.67822H94.0339L89.7792 15.6645L85.5244 9.67822Z",
    fill: "#E22C38"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.747 109.675V140H114.127V125.93H99.3642V140H94.7871V109.675H99.3642V121.801H114.127V109.675H118.747Z",
    fill: "#E22C38"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.687 29.5818C124.699 29.2541 124.011 28.2928 124.011 27.1349C124.011 25.6711 125.128 24.5132 126.525 24.5132C127.965 24.5132 129.082 25.6711 129.082 27.1349C129.082 28.2928 128.373 29.2541 127.363 29.6255L129.791 34.7379H123.259L125.687 29.5818Z",
    fill: "#E22C38"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.947 127.634L130.953 140H126.333L136.755 124.357L126.806 109.675H132.328L139.57 120.381L146.446 109.675H150.895L141.74 123.614L152.807 140H147.306L138.947 127.634Z",
    fill: "#E22C38"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.427 29.8222L146.209 24.5132L150.034 29.8222L146.209 35.1312L142.427 29.8222Z",
    fill: "#E22C38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoorg4);
export default __webpack_public_path__ + "static/media/coorg4.b646a9350edc1b419f81241d18d1477b.svg";
export { ForwardRef as ReactComponent };